import { Box } from '@mui/material'
import React from 'react'
import UserNavbar from './UserNavbar'
import { Outlet } from 'react-router-dom'

const UserDashboard = () => {
  return (
    <Box className='App'>
      <UserNavbar />
      <Box sx={{px: 7}}>
        <Outlet />
      </Box>
    </Box>
  )
}

export default UserDashboard
